export default __webpack_public_path__ + "static/media/sans.b6f3b974.png";